import type { CSSProperties } from 'react';
import { useT } from '@/shared/lib/i18n';

export type PauseButtonProps = {
  onClick: () => void;
  className?: string;
  style?: CSSProperties;
};

/**
 * Floating pause button — top-right corner inside the in-game stage. Small
 * neutral square with two pause bars. Opens the `PauseMenu` sheet.
 */
export const PauseButton = ({ onClick, className, style }: PauseButtonProps) => {
  const t = useT();
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={t('pause.button')}
      className={[
        'flex h-9 w-9 items-center justify-center rounded-full border-[2px] border-ink bg-cream text-ink transition-transform active:translate-x-[1px] active:translate-y-[1px]',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
      style={{ boxShadow: 'var(--shadow-stamp-md)', ...style }}
    >
      <svg width="12" height="12" viewBox="0 0 12 12" role="img" aria-hidden>
        <title>{t('pause.button')}</title>
        <rect x="3" y="2" width="2" height="8" fill="var(--color-ink)" />
        <rect x="7" y="2" width="2" height="8" fill="var(--color-ink)" />
      </svg>
    </button>
  );
};
